import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.backgroundColor || '#25D366'};
  border-radius: 50%;
   padding: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  position: fixed;
  bottom: 12px;
  right: 28px;
  z-index: 9999;
  width: 62px;
  height: 62px;


   @media (max-width: 770px) {
    width: 60px;
    height: 60px;
  }

  @media (max-width: 770px) {
    right: 16px;
    bottom: 112px;
  }
`;

export const CloseIcon = styled.div`
  width: 12px;
  height: 12px;
  position: absolute;
  right: 0px;
  top: -12px;
  cursor: pointer;
`;

export const Link = styled.a``;

export const Img = styled.img`

      width: 48px;
    height: 48px;

   @media (max-width: 770px) {
    width: 40px;
    height: 40px;
  }
`;
